<template>
  <div class="mb-3">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" header-bg-variant="primary">
        <h6 class="text-white">
          {{ title }}
          <b-button
            size="sm"
            class="float-right mb-1"
            @click="show = !show"
          >
            <i class="fas" :class="show ? 'fa-minus' : 'fa-plus'"/>
          </b-button>
        </h6>
      </b-card-header>
      <b-collapse :visible="show" >
        <b-card-body>
          <slot />
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
import { defineComponent, ref } from '@vue/composition-api'

export default defineComponent({
  name: 'AccordionFilters',
  props: {
    title: {
      type: String,
      default: 'FILTROS'
    },
    showDefault: {
      default: false,
      type: Boolean
    }
  },
  setup (props) {
    const show = ref(false)

    if (props.showDefault) {
      console.log('show default >>> ', props.showDefault)
      show.value = props.showDefault
    }

    return {
      show
    }
  }
})
</script>
<style scoped>
.card-header {
  padding: 5px 10px 0px 10px !important;
}
</style>
